export const RENTACAR_WEBSITE_ENDPOINT = 'https://rentacar.be';

/**
 * MFA endpoints — first-time enrollment and the returning-user challenge.
 *
 * `MFA_ENDPOINT_PREFIX` is load-bearing beyond routing: `src/api/index.ts` uses it to exempt these
 * calls from the global "401 means log the user out and hard-redirect" handler, because both flows
 * run pre-auth and their expected failures are 401s the screens handle themselves —
 * [MFA] CODE_INVALID and [MFA] SESSION_EXPIRED during enrollment, [MFA] CHALLENGE_CODE_INVALID and
 * [MFA] SESSION_EXPIRED during a challenge. The match there is case-sensitive, so every path below
 * must keep this exact prefix — a rename that breaks it compiles and lints clean and silently
 * restores a hard reload on the user's first mistyped digit.
 */
export const MFA_ENDPOINT_PREFIX = 'Auth/Mfa';
export const MFA_ENROLL_ENDPOINT = `${MFA_ENDPOINT_PREFIX}/Enroll`;
export const MFA_ENROLL_CONFIRM_ENDPOINT = `${MFA_ENROLL_ENDPOINT}/Confirm`;
export const MFA_VERIFY_ENDPOINT = `${MFA_ENDPOINT_PREFIX}/Verify`;

/**
 * Answers the *same* challenge as `MFA_VERIFY_ENDPOINT`, with one of the eight single-use recovery
 * codes issued at enrollment instead of a live authenticator code. Nested under `/Verify` so it
 * keeps the `Auth/Mfa` prefix, and with it the 401 exemption described above — its expected
 * failures are [MFA] BACKUP_CODE_INVALID and [MFA] SESSION_EXPIRED.
 */
export const MFA_VERIFY_BACKUP_CODE_ENDPOINT = `${MFA_VERIFY_ENDPOINT}/BackupCode`;

/**
 * Mints a pending-enrollment mfaToken for a user who already holds a session — the grace-period
 * banner's "set up now". The only MFA endpoint that requires the ordinary bearer token; the request
 * interceptor attaches it automatically because a grace-period user is signed in.
 */
export const MFA_OPT_IN_ENDPOINT = `${MFA_ENDPOINT_PREFIX}/OptIn`;
